import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import type { DividerProps } from '@mui/material';

type Props = {
  label?: string;
  variant?: 'default' | 'section' | 'inset' | 'middle';
  orientation?: DividerProps['orientation'];
  sx?: any;
  dividerSx?: any;
  spacing?: number;
  color?: string;
};

export const SectionDivider: React.FC<Props> = ({
  label,
  variant = 'default',
  orientation = 'horizontal',
  sx = {},
  dividerSx = {},
  spacing = 2,
  color = 'divider'
}) => {
  const getVariantStyles = (): DividerProps['sx'] => {
    switch (variant) {
      case 'section':
        return {
          borderColor: color,
          borderWidth: 1,
          my: spacing
        };
      case 'inset':
        return {
          borderColor: color,
          mx: 2,
          my: spacing
        };
      case 'middle':
        return {
          borderColor: color,
          width: '50%',
          mx: 'auto',
          my: spacing
        };
      default:
        return {
          borderColor: color,
          my: spacing
        };
    }
  };

  if (label) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          my: spacing,
          ...sx
        }}
      >
        <Divider
          orientation={orientation}
          sx={{
            flex: 1,
            borderColor: color,
            ...dividerSx
          }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ px: 2 }}>
          {label}
        </Typography>
        <Divider
          orientation={orientation}
          sx={{
            flex: 1,
            borderColor: color,
            ...dividerSx
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={sx}>
      <Divider
        orientation={orientation}
        sx={{
          ...getVariantStyles(),
          ...dividerSx
        }}
      />
    </Box>
  );
};
